import { OInfoPage } from "@dnvgl-onefoundation/onedesign-react";

const NotFoundPage = () => {
  return (
    <div style={{ height: "800px" }}>
      <OInfoPage iconClass="fa-cogs">
        <h2 className="info-page-title">Not Found!</h2>
        <p>Please contact your DNV Administrator</p>
        <p>
          <a href="/">Go back to homepage</a>
        </p>
      </OInfoPage>
    </div>
  );
};

export default NotFoundPage;
